import React from 'react';
import { ArchivedFile } from 'src/models/archived-file';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { FileRef, abortableFetch } from '@eas/common-web';

const openImageInNewTab = async (file: FileRef) => {
  const response = await abortableFetch(`/api/zsd/file/${file.id}`).raw();
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
};
const downloadImage = async (file: FileRef) => {
  const response = await abortableFetch(`/api/zsd/file/${file.id}`).raw();
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = file?.name ?? file.id;
  link.click();
  window.URL.revokeObjectURL(url);
};

export function OpenImage({
  archivedFile,
  showOpenInCurrent = true,
  showOpenInNew = true,
}: {
  archivedFile: ArchivedFile;
  showOpenInCurrent?: boolean;
  showOpenInNew?: boolean;
}) {
  return (
    <div
      key={archivedFile.file?.id}
      style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: '8px',
      }}
    >
      {showOpenInCurrent && (
        <IconButton
          size="small"
          color="primary"
          onClick={() => downloadImage(archivedFile.file)}
        >
          <GetAppIcon color="primary" />
        </IconButton>
      )}

      {showOpenInNew && (
        <IconButton
          size="small"
          color="primary"
          onClick={() => openImageInNewTab(archivedFile.file)}
        >
          <OpenInNewIcon color="primary" />
        </IconButton>
      )}
    </div>
  );
}
